import React from 'react';
import { motion } from 'framer-motion';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center">
      <div className="relative w-16 h-16">
        <motion.div
          className="absolute inset-0 rounded-2xl border-2 border-[#ff5500]/20"
          animate={{ rotate: 360 }}
          transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
        />
        <motion.div
          className="absolute inset-2 rounded-xl border-2 border-t-[#ff5500] border-r-transparent border-b-[#00D2B4] border-l-transparent"
          animate={{ rotate: -360 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'linear' }}
        />
        <div className="absolute inset-0 flex items-center justify-center font-heading font-extrabold text-sm text-[#ff5500]">
          H
        </div>
      </div>
      <span className="font-mono text-xs uppercase tracking-widest text-zinc-400 mt-6 animate-pulse">
        Carregando Módulos Hiperbite...
      </span>
    </div>
  );
};
